import { MatDialogModule } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FeatureUploadImportFilesModule } from '@unico-people/shared/dashboard/feature-upload-import-files';
import { EmployeeImportRoutingModule } from './employee-import-routing.module';

import { TopNavigationModule } from '../../components/top-navigation/top-navigation.module';
import { EmployeeImportComponent } from './employee-import.component';

@NgModule({
  declarations: [EmployeeImportComponent],
  imports: [CommonModule, EmployeeImportRoutingModule, TopNavigationModule, FeatureUploadImportFilesModule, MatDialogModule]
})
export class EmployeeImportModule {}
